import React, { Component } from 'react';
import { connect } from 'react-redux';
import salesTaxTotal from '../../selectors/salesTaxTotal.selector';
import TextInput from '../../components/TextInput';

class SalesTaxTotal extends Component {
  render() {
    const { total } = this.props;
    return (
      <div className="Row Row-finalTotalRow">
        <TextInput tabIndex="-1" className="Row-total Row-finalTotal" id="SNewTotal" tooltip="Registration Total" value={total || '0.00'} readOnly />
        <label className="Row-finalTotalLabel" htmlFor="SNewTotal">SALES TAX TOTAL</label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    total: salesTaxTotal(state),
  };
};

export default connect(mapStateToProps)(SalesTaxTotal);
